"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gist = void 0;
const react_1 = __importStar(require("react"));
const generateGistUrl = (username = '', id = '', filename = '') => {
    let url = `https://gist.github.com/${username}/${id}.js`;
    if (filename) {
        url += `&file=${filename}`;
    }
    return url;
};
const getGistId = (username, id, filename) => {
    return filename ? `gist-${username}-${id}-${filename}` : `gist-${username}-${id}`;
};
const updateContent = (username, id, filename, iframe) => {
    if (!username || !id || !iframe || !iframe.current) {
        return null;
    }
    let doc = iframe.current.document;
    if (iframe.current.contentDocument)
        doc = iframe.current.contentDocument;
    else if (iframe.current.contentWindow)
        doc = iframe.current.contentWindow.document;
    const gistLink = generateGistUrl(username, id, filename);
    const gistScript = `<script type="text/javascript" src="${gistLink}"></script>`;
    const elementId = getGistId(username, id, filename);
    const resizeScript = `onload="parent.document.getElementById('${elementId}').style.height=document.body.scrollHeight + 'px'"`;
    const iframeHtml = `<html><head><base target="_parent"></head><body ${resizeScript}>${gistScript}</body></html>`;
    doc.open();
    doc.writeln(iframeHtml);
    doc.close();
};
const Gist = ({ username = '', id = '', filename = '' }) => {
    const iframeNode = (0, react_1.useRef)(null);
    const gistElementId = getGistId(username, id, filename);
    (0, react_1.useEffect)(() => {
        updateContent(username, id, filename, iframeNode);
    }, [username, filename, id]);
    if (!id || !username) {
        return null;
    }
    return (react_1.default.createElement("iframe", { title: `${gistElementId}`, ref: iframeNode, width: "100%", frameBorder: 0, id: gistElementId }));
};
exports.Gist = Gist;
exports.default = exports.Gist;
//# sourceMappingURL=Gist.js.map